import React from 'react'
import { connect } from 'react-redux'
import { Icon, ErrorBoundary } from 'components'
import { getPlanTakeaways } from 'store/selectors'

function Summary(props) {
  const { planTakeaways, numberOfGoals, location } = props
  const { totalRegularInvestment, weightedAverageStepUp } = planTakeaways
  const editPanelClosed = !(
    location.pathname.includes('edit') || location.pathname.includes('profile')
  )
  return (
    <div className="summary">
      <ErrorBoundary>
        {editPanelClosed && (
          <div className="summary__legend">
            <div>
              <h5>SUMMARY</h5>
              <button className="minimal" style={{ visibility: 'hidden' }}>
                <Icon name="share-primary" small />SHARE
              </button>
            </div>
          </div>
        )}
        <div className="summary__takeaway">
          <h3>
            Invest <strong>₹{totalRegularInvestment}/mo</strong> towards{' '}
            {numberOfGoals} goal{numberOfGoals > 1 && 's'}{' '}
            <strong>this year</strong>
          </h3>
          <span>Step up by {weightedAverageStepUp}% every year</span>
        </div>
      </ErrorBoundary>
    </div>
  )
}

export default connect(state => ({
  planTakeaways: getPlanTakeaways(state),
  numberOfGoals: Object.values(state.goals).filter(
    goal => goal.investStartAge === state.profile.age
  ).length,
}))(Summary)



// WEBPACK FOOTER //
// ./src/components/layout/Summary.js